export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'ashley@ugc3.co.uk'; 